import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { CircularProgress } from "@mui/material";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useDashboardStore } from "./store/dashboardStore";
import { useNavigate } from "react-router-dom";

export const FalsePositiveReductionGraph = () => {
  const {
    noFPData,
    setNoFPData,
    setFalsePositiveData,
    falsePositiveData,
    getFalsePositiveData,
  } = useDashboardStore();

  const retryText = (
    <>
      <RefreshIcon fontSize="small" />
      &nbsp;Retry
    </>
  );

  const navigate = useNavigate();

  return (
    <div className="w-full min-w-0 bg-white px-4 pt-4 pb-5 sm:px-6">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-actuate-blue font-mulish text-[26px] font-bold">
          False Positive Reduction
        </p>
        <p className="text-actuate-blue font-mulish text-[16px]">
          Last 5 Days
        </p>
      </div>

      {!falsePositiveData && !noFPData && (
        <div className="flex h-[280px] flex-col items-center justify-center">
          <CircularProgress size={25} />
          <div className="font-mulish text-actuate-blue test-bold pt-2">
            Fetching Data...
          </div>
        </div>
      )}
      {!falsePositiveData && noFPData && (
        <div className="flex h-[280px] flex-col items-center justify-center">
          <div className="font-mulish text-actuate-blue test-bold text-[20px]">
            Error fetching data.
          </div>
          <OrangeTextButton
            onClick={() => {
              setNoFPData(false);
              setFalsePositiveData(null);
              getFalsePositiveData(navigate);
            }}
            text={retryText}
            disabled={false}
          />
        </div>
      )}

      {falsePositiveData && !noFPData && (
        <div className="mt-4 h-[280px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={falsePositiveData}
              margin={{
                top: 5,
                right: 20,
                left: 30,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis allowDecimals={false} />
              {falsePositiveData && falsePositiveData.length > 0 && (
                <Tooltip />
              )}
              <Legend verticalAlign="top" height={36} />
              <Bar
                dataKey="detections"
                stackId="a"
                fill="#283E6D"
                name="Detections"
              />
              <Bar
                dataKey="motion_counts"
                stackId="b"
                fill="#FF8400"
                name="Motion Counts"
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
